
document.getElementById('product-form-installment').addEventListener("submit", function(evt) {

  evt.preventDefault();

  window.store.dispatch('openNotification')

}, true);

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const qty = document.querySelector('[name=quantity]').value

      
      const submitButton = this.querySelector('[type="submit"]');
      const submitButtons = this.querySelectorAll('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;


      this.handleErrorMessage();

      const id = this.form.id.value

      if(window.store.state.customer.isWholesale){
        window.store.dispatch('addToCart',{ id: id, qty: qty })

      }else{
        const subscription = document.querySelector('.rc_widget__option__input--subsave')?.checked
        const selling_plan = document.querySelector('[name="selling_plan"]')?.value
        window.store.dispatch('addToCart',{ id: id, qty: qty, selling_plan })
        // const properties = {
        //   "shipping_interval_frequency": frequency,
        //   "shipping_interval_unit_type": 'days'
        // }
        // axios.post('/cart/add.js',{
        //   id,
        //   qty, 
        //   selling_plan
        // })
        // document.getElementById('product-form-installment').submit()
        
      }

      return

/*       
      const formData = new FormData(this.form);

      return 
 */
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // let a = this.cartNotification.getSectionsToRender().map((section) => section.id)
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      // formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          store.dispatch('getCart',{})
          // store.dispatch('showCartNewNotification')
          store.dispatch('openNotification')
          // this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((x)=>{
            x.classList.remove('loading');
            x.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          })
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
